// extracted by mini-css-extract-plugin
export default {"messageContainer":"MnOXmVtujdOcCb5DjM9n","checkInbox":"UauAmVwhAp54SCReb4TV"};